export const ChoosFileIcon = () => {
  return (
    <>
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.129 2.68558C14.3656 2.64067 13.5154 2.89879 12.7073 3.70691L3.7073 12.7069C2.39918 14.015 1.95356 15.4277 2.02972 16.7223C2.10732 18.0416 2.73296 19.3184 3.7073 20.2927C4.68163 21.267 5.95843 21.8927 7.27766 21.9703C8.57232 22.0464 9.98496 21.6008 11.2931 20.2927L20.2931 11.2927L21.7073 12.7069L12.7073 21.7069C11.0154 23.3988 9.05307 24.0782 7.16022 23.9668C5.29195 23.8569 3.56875 22.9826 2.29308 21.7069C1.01742 20.4312 0.143065 18.708 0.033167 16.8398C-0.0781768 14.9469 0.601206 12.9846 2.29308 11.2927L11.2931 2.2927C12.485 1.10082 13.8848 0.608938 15.2464 0.689032C16.5834 0.76768 17.8066 1.39204 18.7073 2.2927C19.608 3.19336 20.2323 4.41657 20.311 5.75358C20.3911 7.11518 19.8992 8.51504 18.7073 9.70691L9.7073 18.7069C9.01542 19.3988 8.17807 19.7032 7.34772 19.6543C6.54195 19.6069 5.81875 19.2326 5.29309 18.7069C4.76742 18.1812 4.39307 17.458 4.34567 16.6523C4.29682 15.8219 4.60121 14.9846 5.29309 14.2927L14.2931 5.2927L15.7073 6.70691L6.7073 15.7069C6.39918 16.015 6.32856 16.3027 6.34222 16.5348C6.35732 16.7916 6.48296 17.0684 6.7073 17.2927C6.93163 17.517 7.20843 17.6427 7.46516 17.6578C7.69732 17.6714 7.98496 17.6008 8.29309 17.2927L17.2931 8.2927C18.1012 7.48458 18.3593 6.63443 18.3144 5.87103C18.2681 5.08304 17.8924 4.30625 17.2931 3.70691C16.6937 3.10758 15.917 2.73193 15.129 2.68558Z"
          fill="#5D5E60"
        />
      </svg>
    </>
  );
};
export const VideoPlayIcon = () => {
  return (
    <>
      <svg
        className="cursor-pointer size-video-icon"
        width="96"
        height="96"
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="28" y="24" width="40" height="48" fill="white" />
        <path
          d="M48 6C24.8063 6 6 24.8063 6 48C6 71.1937 24.8063 90 48 90C71.1937 90 90 71.1937 90 48C90 24.8063 71.1937 6 48 6ZM61.5094 48.6469L41.0344 63.5437C40.9221 63.6244 40.7898 63.6726 40.652 63.6829C40.5141 63.6933 40.3761 63.6654 40.2531 63.6025C40.13 63.5395 40.0267 63.4438 39.9545 63.326C39.8823 63.2081 39.844 63.0726 39.8438 62.9344V33.1594C39.8433 33.0209 39.8812 32.885 39.9533 32.7667C40.0253 32.6484 40.1287 32.5524 40.252 32.4893C40.3753 32.4262 40.5137 32.3984 40.6518 32.4092C40.7899 32.4199 40.9223 32.4686 41.0344 32.55L61.5094 47.4375C61.6061 47.5059 61.685 47.5965 61.7395 47.7017C61.7939 47.807 61.8224 47.9237 61.8224 48.0422C61.8224 48.1607 61.7939 48.2774 61.7395 48.3826C61.685 48.4878 61.6061 48.5785 61.5094 48.6469Z"
          fill="#127CF9"
        />
      </svg>
    </>
  );
};
export const BellIcon = () => {
  return (
    <div className="cursor-pointer">
      <svg
        width="35"
        height="35"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.9 18.7536L21.6733 18.5536C21.0303 17.9807 20.4674 17.3236 20 16.6003C19.4895 15.602 19.1835 14.5117 19.1 13.3936V10.1003C19.1044 8.344 18.4673 6.64658 17.3085 5.32691C16.1496 4.00724 14.5488 3.15617 12.8067 2.93359V2.07359C12.8067 1.83755 12.7129 1.61118 12.546 1.44427C12.3791 1.27736 12.1527 1.18359 11.9167 1.18359C11.6806 1.18359 11.4542 1.27736 11.2873 1.44427C11.1204 1.61118 11.0267 1.83755 11.0267 2.07359V2.94693C9.30016 3.18555 7.71864 4.04176 6.57501 5.357C5.43138 6.67223 4.80315 8.35736 4.80666 10.1003V13.3936C4.72316 14.5117 4.41718 15.602 3.90666 16.6003C3.44725 17.3218 2.89346 17.9788 2.25999 18.5536L2.03333 18.7536V20.6336H21.9V18.7536Z"
          fill="#17191C"
        />
        <path
          d="M10.2133 21.334C10.2718 21.7566 10.4812 22.1437 10.8028 22.424C11.1245 22.7042 11.5367 22.8586 11.9633 22.8586C12.3899 22.8586 12.8021 22.7042 13.1238 22.424C13.4455 22.1437 13.6549 21.7566 13.7133 21.334H10.2133Z"
          fill="#17191C"
        />
      </svg>
    </div>
  );
};

export const DollorSign = () => {
  return (
    <>
      <svg
        width="23"
        height="42"
        viewBox="0 0 23 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.368 27.7725L22.3698 27.9335C22.3726 30.1631 21.5375 32.3124 20.03 33.9552L20.0353 33.9482C18.465 35.6778 16.3413 36.8065 14.0293 37.1403L13.975 37.1473V41.2773C13.975 41.4689 13.8989 41.6528 13.7633 41.7883C13.6278 41.9239 13.4439 42 13.2523 42H13.2225H13.2243H10.062C9.8636 41.9977 9.67396 41.9179 9.53365 41.7776C9.39335 41.6373 9.31352 41.4477 9.31125 41.2492V37.1473C8.25669 37.0064 7.22048 36.7517 6.22075 36.3877L6.324 36.421C4.83068 35.9215 3.42954 35.1801 2.1765 34.2265L2.2115 34.2528C1.82877 33.9759 1.46132 33.6786 1.11075 33.362L1.123 33.3725C0.928168 33.1858 0.791668 33.0458 0.713501 32.9525C0.586983 32.8267 0.512285 32.658 0.504184 32.4798C0.496082 32.3015 0.555167 32.1268 0.669751 31.99L0.668001 31.9918L3.08125 28.8277C3.14537 28.7452 3.22656 28.6774 3.31929 28.6291C3.41201 28.5807 3.51407 28.553 3.6185 28.5478H3.62025C3.72403 28.5287 3.83104 28.5384 3.92973 28.5757C4.02842 28.613 4.11504 28.6765 4.18025 28.7595L4.182 28.7612L4.2275 28.8068C5.80978 30.2555 7.74628 31.2612 9.8415 31.7223L9.922 31.738C10.4435 31.857 11.042 31.9253 11.6563 31.9253L11.7648 31.927C12.974 31.927 14.094 31.549 15.0163 30.905L14.997 30.9172C15.4622 30.6028 15.839 30.1744 16.0914 29.6728C16.3438 29.1713 16.4635 28.6134 16.439 28.0525V28.0595C16.439 27.5993 16.3078 27.1705 16.082 26.8083L16.0872 26.8188C15.8739 26.4574 15.6106 26.1281 15.305 25.8405L15.3032 25.8388C14.8965 25.4976 14.4492 25.2078 13.9715 24.976L13.933 24.9585C13.3077 24.6388 12.7943 24.3886 12.393 24.2078C11.9917 24.0269 11.3669 23.7732 10.5188 23.4465C9.90975 23.1968 9.42908 23.0014 9.07675 22.8603C8.72442 22.7191 8.24375 22.512 7.63475 22.239C7.02575 21.966 6.5375 21.7239 6.17 21.5128C5.8025 21.3016 5.36092 21.0245 4.84525 20.6815C4.39351 20.3904 3.97096 20.0564 3.5835 19.684L3.58525 19.6857C3.2336 19.3299 2.90065 18.9561 2.58775 18.5658L2.565 18.5378C2.2336 18.136 1.95864 17.6909 1.74775 17.2148L1.73375 17.178C1.53049 16.6947 1.36947 16.1946 1.2525 15.6835L1.24025 15.6205C1.10636 15.0338 1.03944 14.4338 1.04075 13.832V13.79V13.7375C1.04075 11.55 1.9175 9.5655 3.34025 8.12L3.3385 8.12175C4.92436 6.47305 6.99674 5.37583 9.25175 4.991L9.31475 4.98225V0.755999V0.748999C9.31475 0.544249 9.4005 0.358749 9.537 0.227499C9.60446 0.15722 9.68543 0.101304 9.77505 0.0631113C9.86467 0.0249184 9.96108 0.00523676 10.0585 0.00524903H13.2558C13.6548 0.00524903 13.9785 0.328999 13.9785 0.727999V0.757749V0.755999V4.88075C14.941 4.98225 15.8195 5.173 16.6612 5.446L16.5685 5.41975C17.3717 5.66475 18.0473 5.9325 18.6965 6.244L18.6055 6.2055C19.1795 6.49075 19.6678 6.783 20.1298 7.1085L20.0947 7.084C20.5614 7.413 20.8659 7.63933 21.0083 7.763C21.1506 7.88667 21.2678 7.99575 21.36 8.09025C21.4859 8.19862 21.5673 8.34966 21.5886 8.51439C21.6099 8.67912 21.5696 8.84591 21.4755 8.98275L21.4773 8.981L19.5837 12.404C19.5365 12.5092 19.4616 12.5996 19.3669 12.6656C19.2723 12.7315 19.1616 12.7706 19.0465 12.7785H19.0448C18.9336 12.8016 18.8186 12.7988 18.7088 12.7703C18.5989 12.7417 18.4971 12.6883 18.4112 12.614H18.413C18.3663 12.5673 18.2532 12.474 18.0735 12.334C17.8938 12.194 17.5893 11.9869 17.16 11.7127C16.7434 11.4457 16.3103 11.2055 15.8633 10.9935L15.7898 10.962C15.2511 10.7143 14.6911 10.5158 14.1168 10.3688L14.0433 10.353C13.3909 10.1744 12.7176 10.0838 12.0413 10.0835H12.0395C10.7435 10.0241 9.46266 10.3824 8.3855 11.1055L8.40825 11.0915C7.81248 11.4874 7.36908 12.0741 7.15092 12.7553C6.93275 13.4365 6.95279 14.1717 7.20775 14.84L7.20075 14.819C7.36175 15.204 7.59625 15.5295 7.89025 15.7902L7.89375 15.792C8.1755 16.0562 8.4765 16.31 8.7915 16.5462L8.8195 16.5655C9.19575 16.8245 9.628 17.0678 10.0813 17.2708L10.1338 17.2917C10.7194 17.5647 11.1919 17.7759 11.5513 17.9252C11.9106 18.0746 12.4578 18.2892 13.1928 18.5693C14.0211 18.8819 14.654 19.1281 15.0915 19.3078C15.529 19.4874 16.1228 19.761 16.873 20.1285C17.5049 20.4252 18.1138 20.7686 18.6948 21.1558L18.644 21.1243C19.1865 21.5093 19.659 21.8943 20.1087 22.3055L20.0983 22.295C20.583 22.7185 20.996 23.2085 21.325 23.7563L21.3408 23.7843C21.6313 24.297 21.8815 24.8937 22.0635 25.5185L22.0793 25.578C22.27 26.2168 22.3785 26.9517 22.3785 27.7113V27.7847V27.7812L22.368 27.7725Z"
          fill="#43C093"
        />
      </svg>
    </>
  );
};
export const DeleteIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5 5C19.5 5.24493 19.41 5.48134 19.2473 5.66437C19.0845 5.84741 18.8603 5.96434 18.617 5.993L18.5 6H17.655L16.424 18.52C16.357 19.1994 16.0397 19.8295 15.5338 20.2879C15.0279 20.7462 14.3697 21.0001 13.687 21H6.313C5.63035 21.0001 4.97207 20.7462 4.4662 20.2879C3.96033 19.8295 3.64302 19.1994 3.576 18.52L2.345 6H1.5C1.23478 6 0.98043 5.89464 0.792893 5.70711C0.605357 5.51957 0.5 5.26522 0.5 5C0.5 4.73478 0.605357 4.48043 0.792893 4.29289C0.98043 4.10536 1.23478 4 1.5 4H6.5C6.5 3.54037 6.59053 3.08525 6.76642 2.66061C6.94231 2.23597 7.20012 1.85013 7.52513 1.52513C7.85013 1.20012 8.23597 0.942313 8.66061 0.766422C9.08525 0.59053 9.54037 0.5 10 0.5C10.4596 0.5 10.9148 0.59053 11.3394 0.766422C11.764 0.942313 12.1499 1.20012 12.4749 1.52513C12.7999 1.85013 13.0577 2.23597 13.2336 2.66061C13.4095 3.08525 13.5 3.54037 13.5 4H18.5C18.7652 4 19.0196 4.10536 19.2071 4.29289C19.3946 4.48043 19.5 4.73478 19.5 5ZM12.25 8.25C12.0688 8.25001 11.8937 8.31564 11.7571 8.43477C11.6205 8.55389 11.5316 8.71845 11.507 8.898L11.5 9V16L11.507 16.102C11.5317 16.2815 11.6206 16.446 11.7571 16.5651C11.8937 16.6842 12.0688 16.7498 12.25 16.7498C12.4312 16.7498 12.6063 16.6842 12.7429 16.5651C12.8794 16.446 12.9683 16.2815 12.993 16.102L13 16V9L12.993 8.898C12.9684 8.71845 12.8795 8.55389 12.7429 8.43477C12.6063 8.31564 12.4312 8.25001 12.25 8.25ZM7.75 8.25C7.56876 8.25001 7.39366 8.31564 7.25707 8.43477C7.12048 8.55389 7.03165 8.71845 7.007 8.898L7 9V16L7.007 16.102C7.0317 16.2815 7.12055 16.446 7.25714 16.5651C7.39372 16.6842 7.5688 16.7498 7.75 16.7498C7.9312 16.7498 8.10628 16.6842 8.24286 16.5651C8.37945 16.446 8.4683 16.2815 8.493 16.102L8.5 16V9L8.493 8.898C8.46835 8.71845 8.37952 8.55389 8.24293 8.43477C8.10634 8.31564 7.93124 8.25001 7.75 8.25ZM10 2.5C9.60218 2.5 9.22064 2.65804 8.93934 2.93934C8.65804 3.22064 8.5 3.60218 8.5 4H11.5C11.5 3.60218 11.342 3.22064 11.0607 2.93934C10.7794 2.65804 10.3978 2.5 10 2.5Z"
          fill="#5D5E60"
        />
      </svg>
    </>
  );
};
export const EditIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0H6C2.691 0 0 2.691 0 6V19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20H14C17.309 20 20 17.309 20 14V6C20 2.691 17.309 0 14 0ZM6.999 15H5V13.001L10.53 7.479L12.529 9.478L6.999 15ZM13.472 8.535L11.473 6.536L12.997 5.013L14.996 7.012L13.472 8.535Z"
        fill="white"
      />
    </svg>
  );
};
export const ThreeDotsIcon = () => {
  return (
    <svg
      width="16"
      height="4"
      viewBox="0 0 16 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4C8.53043 4 9.03914 3.78929 9.41421 3.41421C9.78929 3.03914 10 2.53043 10 2C10 1.46957 9.78929 0.96086 9.41421 0.585787C9.03914 0.210714 8.53043 0 8 0C7.46957 0 6.96086 0.210714 6.58579 0.585787C6.21071 0.96086 6 1.46957 6 2C6 2.53043 6.21071 3.03914 6.58579 3.41421C6.96086 3.78929 7.46957 4 8 4ZM2 4C2.53043 4 3.03914 3.78929 3.41421 3.41421C3.78929 3.03914 4 2.53043 4 2C4 1.46957 3.78929 0.96086 3.41421 0.585787C3.03914 0.210714 2.53043 0 2 0C1.46957 0 0.960859 0.210714 0.585786 0.585787C0.210714 0.96086 0 1.46957 0 2C0 2.53043 0.210714 3.03914 0.585786 3.41421C0.960859 3.78929 1.46957 4 2 4ZM14 4C14.5304 4 15.0391 3.78929 15.4142 3.41421C15.7893 3.03914 16 2.53043 16 2C16 1.46957 15.7893 0.96086 15.4142 0.585787C15.0391 0.210714 14.5304 0 14 0C13.4696 0 12.9609 0.210714 12.5858 0.585787C12.2107 0.96086 12 1.46957 12 2C12 2.53043 12.2107 3.03914 12.5858 3.41421C12.9609 3.78929 13.4696 4 14 4Z"
        fill="#17191C"
      />
    </svg>
  );
};
export const ReportPersonIcon = () => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z"
        fill="#17191C"
      />
    </svg>
  );
};
export const DisputeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 18H6V22.081L11.101 18H16C17.103 18 18 17.103 18 16V8C18 6.897 17.103 6 16 6H4C2.897 6 2 6.897 2 8V16C2 17.103 2.897 18 4 18Z"
        fill="#5D5E60"
      />
      <path
        d="M20 2H8C6.897 2 6 2.897 6 4H18C19.103 4 20 4.897 20 6V14C21.103 14 22 13.103 22 12V4C22 2.897 21.103 2 20 2Z"
        fill="#5D5E60"
      />
    </svg>
  );
};

export const ClearMessageIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 5C19.5 5.24493 19.41 5.48134 19.2473 5.66437C19.0845 5.84741 18.8603 5.96434 18.617 5.993L18.5 6H17.655L16.424 18.52C16.357 19.1994 16.0397 19.8295 15.5338 20.2879C15.0279 20.7462 14.3697 21.0001 13.687 21H6.313C5.63035 21.0001 4.97207 20.7462 4.4662 20.2879C3.96033 19.8295 3.64302 19.1994 3.576 18.52L2.345 6H1.5C1.23478 6 0.98043 5.89464 0.792893 5.70711C0.605357 5.51957 0.5 5.26522 0.5 5C0.5 4.73478 0.605357 4.48043 0.792893 4.29289C0.98043 4.10536 1.23478 4 1.5 4H6.5C6.5 3.54037 6.59053 3.08525 6.76642 2.66061C6.94231 2.23597 7.20012 1.85013 7.52513 1.52513C7.85013 1.20012 8.23597 0.942313 8.66061 0.766422C9.08525 0.59053 9.54037 0.5 10 0.5C10.4596 0.5 10.9148 0.59053 11.3394 0.766422C11.764 0.942313 12.1499 1.20012 12.4749 1.52513C12.7999 1.85013 13.0577 2.23597 13.2336 2.66061C13.4095 3.08525 13.5 3.54037 13.5 4H18.5C18.7652 4 19.0196 4.10536 19.2071 4.29289C19.3946 4.48043 19.5 4.73478 19.5 5ZM12.25 8.25C12.0688 8.25001 11.8937 8.31564 11.7571 8.43477C11.6205 8.55389 11.5316 8.71845 11.507 8.898L11.5 9V16L11.507 16.102C11.5317 16.2815 11.6206 16.446 11.7571 16.5651C11.8937 16.6842 12.0688 16.7498 12.25 16.7498C12.4312 16.7498 12.6063 16.6842 12.7429 16.5651C12.8794 16.446 12.9683 16.2815 12.993 16.102L13 16V9L12.993 8.898C12.9684 8.71845 12.8795 8.55389 12.7429 8.43477C12.6063 8.31564 12.4312 8.25001 12.25 8.25ZM7.75 8.25C7.56876 8.25001 7.39366 8.31564 7.25707 8.43477C7.12048 8.55389 7.03165 8.71845 7.007 8.898L7 9V16L7.007 16.102C7.0317 16.2815 7.12055 16.446 7.25714 16.5651C7.39372 16.6842 7.5688 16.7498 7.75 16.7498C7.9312 16.7498 8.10628 16.6842 8.24286 16.5651C8.37945 16.446 8.4683 16.2815 8.493 16.102L8.5 16V9L8.493 8.898C8.46835 8.71845 8.37952 8.55389 8.24293 8.43477C8.10634 8.31564 7.93124 8.25001 7.75 8.25ZM10 2.5C9.60218 2.5 9.22064 2.65804 8.93934 2.93934C8.65804 3.22064 8.5 3.60218 8.5 4H11.5C11.5 3.60218 11.342 3.22064 11.0607 2.93934C10.7794 2.65804 10.3978 2.5 10 2.5Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const BackIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7166 0.636907C5.71672 0.504198 5.67542 0.374772 5.59849 0.266742C5.52156 0.158713 5.41284 0.0774849 5.28755 0.0344262C5.16226 -0.00863255 5.02666 -0.0113673 4.89974 0.0266046C4.77283 0.0645766 4.66093 0.141355 4.57972 0.246195L0.133818 5.97324C0.0470881 6.08494 0 6.22243 0 6.36395C0 6.50547 0.0470881 6.64296 0.133818 6.75466L4.57972 12.4817C4.66093 12.5865 4.77283 12.6633 4.89974 12.7013C5.02666 12.7393 5.16226 12.7365 5.28755 12.6935C5.41284 12.6504 5.52156 12.5692 5.59849 12.4612C5.67542 12.3531 5.71672 12.2237 5.7166 12.091V9.552C9.13296 9.62327 10.7741 10.273 11.5985 10.9793C12.3823 11.6506 12.5258 12.4403 12.6751 13.2676L12.7138 13.4808C12.7423 13.6333 12.8255 13.7701 12.9476 13.8655C13.0698 13.9609 13.2225 14.0083 13.3771 13.9988C13.5317 13.9893 13.6775 13.9234 13.7871 13.8137C13.8966 13.704 13.9624 13.558 13.972 13.4031C14.0806 11.6545 13.9174 9.12057 12.6846 7.00092C11.488 4.94364 9.33303 3.36171 5.7166 3.19626V0.636907Z"
        fill="#5D5E60"
      />
    </svg>
  );
};

export const ViewJobIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M12.552 8C12.2868 8 12.0324 8.10536 11.8449 8.29289C11.6574 8.48043 11.552 8.73478 11.552 9C11.552 9.26522 11.6574 9.51957 11.8449 9.70711C12.0324 9.89464 12.2868 10 12.552 10H16.552C16.8172 10 17.0716 9.89464 17.2591 9.70711C17.4466 9.51957 17.552 9.26522 17.552 9C17.552 8.73478 17.4466 8.48043 17.2591 8.29289C17.0716 8.10536 16.8172 8 16.552 8H12.552Z"
        fill="#5D5E60"
      />
      <path
        opacity="0.2"
        d="M12.552 17C12.2868 17 12.0324 17.1054 11.8449 17.2929C11.6574 17.4804 11.552 17.7348 11.552 18C11.552 18.2652 11.6574 18.5196 11.8449 18.7071C12.0324 18.8946 12.2868 19 12.552 19H16.552C16.8172 19 17.0716 18.8946 17.2591 18.7071C17.4466 18.5196 17.552 18.2652 17.552 18C17.552 17.7348 17.4466 17.4804 17.2591 17.2929C17.0716 17.1054 16.8172 17 16.552 17H12.552Z"
        fill="#5D5E60"
      />
      <path
        d="M12.552 5C12.2868 5 12.0324 5.10536 11.8449 5.29289C11.6574 5.48043 11.552 5.73478 11.552 6C11.552 6.26522 11.6574 6.51957 11.8449 6.70711C12.0324 6.89464 12.2868 7 12.552 7H20.552C20.8172 7 21.0716 6.89464 21.2591 6.70711C21.4466 6.51957 21.552 6.26522 21.552 6C21.552 5.73478 21.4466 5.48043 21.2591 5.29289C21.0716 5.10536 20.8172 5 20.552 5H12.552Z"
        fill="#5D5E60"
      />
      <path
        d="M12.552 14C12.2868 14 12.0324 14.1054 11.8449 14.2929C11.6574 14.4804 11.552 14.7348 11.552 15C11.552 15.2652 11.6574 15.5196 11.8449 15.7071C12.0324 15.8946 12.2868 16 12.552 16H20.552C20.8172 16 21.0716 15.8946 21.2591 15.7071C21.4466 15.5196 21.552 15.2652 21.552 15C21.552 14.7348 21.4466 14.4804 21.2591 14.2929C21.0716 14.1054 20.8172 14 20.552 14H12.552Z"
        fill="#5D5E60"
      />
      <path
        d="M3.448 4.00391C3.18278 4.00391 2.92843 4.10926 2.74089 4.2968C2.55335 4.48434 2.448 4.73869 2.448 5.00391V10.0039C2.448 10.2691 2.55335 10.5235 2.74089 10.711C2.92843 10.8985 3.18278 11.0039 3.448 11.0039H8.448C8.71321 11.0039 8.96757 10.8985 9.1551 10.711C9.34264 10.5235 9.448 10.2691 9.448 10.0039V5.00391C9.448 4.73869 9.34264 4.48434 9.1551 4.2968C8.96757 4.10926 8.71321 4.00391 8.448 4.00391H3.448Z"
        fill="#5D5E60"
      />
      <path
        d="M3.448 13C3.18278 13 2.92843 13.1054 2.74089 13.2929C2.55335 13.4804 2.448 13.7348 2.448 14V19C2.448 19.2652 2.55335 19.5196 2.74089 19.7071C2.92843 19.8946 3.18278 20 3.448 20H8.448C8.71321 20 8.96757 19.8946 9.1551 19.7071C9.34264 19.5196 9.448 19.2652 9.448 19V14C9.448 13.7348 9.34264 13.4804 9.1551 13.2929C8.96757 13.1054 8.71321 13 8.448 13H3.448Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const ReleaseFundsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.71429 6.6423C1.71429 6.01715 1.96264 5.4176 2.40469 4.97555C2.84674 4.5335 3.44628 4.28516 4.07144 4.28516H19.9286C20.5537 4.28516 21.1533 4.5335 21.5953 4.97555C22.0374 5.4176 22.2857 6.01715 22.2857 6.6423V8.57087H1.71429V6.6423Z"
        fill="#17191C"
      />
      <path
        d="M1.71429 9.85547H22.2857V16.4983C22.2857 17.1235 22.0374 17.723 21.5953 18.1651C21.1533 18.6071 20.5537 18.8555 19.9286 18.8555H4.07144C3.44628 18.8555 2.84674 18.6071 2.40469 18.1651C1.96264 17.723 1.71429 17.1235 1.71429 16.4983V9.85547ZM15.8572 14.0555C15.6526 14.0555 15.4563 14.1367 15.3117 14.2814C15.167 14.4261 15.0857 14.6223 15.0857 14.8269C15.0857 15.0315 15.167 15.2277 15.3117 15.3724C15.4563 15.5171 15.6526 15.5983 15.8572 15.5983H18.4286C18.6332 15.5983 18.8294 15.5171 18.9741 15.3724C19.1187 15.2277 19.2 15.0315 19.2 14.8269C19.2 14.6223 19.1187 14.4261 18.9741 14.2814C18.8294 14.1367 18.6332 14.0555 18.4286 14.0555H15.8572Z"
        fill="#17191C"
      />
    </svg>
  );
};
export const CloseThisTabIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20.0009C8.68642 20.0022 7.38546 19.7444 6.17162 19.2424C4.95777 18.7403 3.85485 18.0037 2.926 17.0749C1.99716 16.146 1.26061 15.0431 0.75853 13.8293C0.256449 12.6154 -0.00131055 11.3145 5.01048e-06 10.0009V9.80088C0.0400133 7.84029 0.655299 5.93469 1.76939 4.3209C2.88348 2.70712 4.44726 1.45631 6.26636 0.72394C8.08547 -0.00843138 10.0797 -0.190075 12.0012 0.201585C13.9227 0.593244 15.6867 1.54094 17.074 2.92688C18.4737 4.32543 19.4271 6.10778 19.8134 8.04837C20.1997 9.98895 20.0017 12.0005 19.2443 13.8285C18.487 15.6565 17.2043 17.2187 15.5588 18.3174C13.9132 19.4162 11.9787 20.002 10 20.0009ZM10 11.4109L12.59 14.0009L14 12.5909L11.41 10.0009L14 7.41088L12.59 6.00088L10 8.59088L7.41001 6.00088L6.00001 7.41088L8.59 10.0009L6.00001 12.5909L7.41001 14.0009L10 11.4119V11.4109Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const AddPaymentIcon = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 21.5C16.299 21.5 21 16.799 21 11C21 5.201 16.299 0.5 10.5 0.5C4.701 0.5 0 5.201 0 11C0 16.799 4.701 21.5 10.5 21.5ZM9.75 7.25C9.75 7.05109 9.82902 6.86032 9.96967 6.71967C10.1103 6.57902 10.3011 6.5 10.5 6.5C10.6989 6.5 10.8897 6.57902 11.0303 6.71967C11.171 6.86032 11.25 7.05109 11.25 7.25V10.25H14.25C14.4489 10.25 14.6397 10.329 14.7803 10.4697C14.921 10.6103 15 10.8011 15 11C15 11.1989 14.921 11.3897 14.7803 11.5303C14.6397 11.671 14.4489 11.75 14.25 11.75H11.25V14.75C11.25 14.9489 11.171 15.1397 11.0303 15.2803C10.8897 15.421 10.6989 15.5 10.5 15.5C10.3011 15.5 10.1103 15.421 9.96967 15.2803C9.82902 15.1397 9.75 14.9489 9.75 14.75V11.75H6.75C6.55109 11.75 6.36032 11.671 6.21967 11.5303C6.07902 11.3897 6 11.1989 6 11C6 10.8011 6.07902 10.6103 6.21967 10.4697C6.36032 10.329 6.55109 10.25 6.75 10.25H9.75V7.25Z"
        fill="white"
      />
    </svg>
  );
};
export const MessageIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V18C0.000305357 18.1772 0.0476888 18.3511 0.1373 18.504C0.226912 18.6569 0.355534 18.7832 0.51 18.87C0.659456 18.9547 0.828212 18.9995 1 19C1.17948 18.9999 1.35564 18.9516 1.51 18.86L6 16.14C6.16597 16.0412 6.35699 15.9926 6.55 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM6 9C5.80222 9 5.60888 8.94135 5.44443 8.83147C5.27998 8.72159 5.15181 8.56541 5.07612 8.38268C5.00043 8.19996 4.98063 7.99889 5.01921 7.80491C5.0578 7.61093 5.15304 7.43275 5.29289 7.29289C5.43275 7.15304 5.61093 7.0578 5.80491 7.01921C5.99889 6.98063 6.19996 7.00043 6.38268 7.07612C6.56541 7.15181 6.72159 7.27998 6.83147 7.44443C6.94135 7.60888 7 7.80222 7 8C7 8.26522 6.89464 8.51957 6.70711 8.70711C6.51957 8.89464 6.26522 9 6 9ZM10 9C9.80222 9 9.60888 8.94135 9.44443 8.83147C9.27998 8.72159 9.15181 8.56541 9.07612 8.38268C9.00043 8.19996 8.98063 7.99889 9.01921 7.80491C9.0578 7.61093 9.15304 7.43275 9.29289 7.29289C9.43275 7.15304 9.61093 7.0578 9.80491 7.01921C9.99889 6.98063 10.2 7.00043 10.3827 7.07612C10.5654 7.15181 10.7216 7.27998 10.8315 7.44443C10.9414 7.60888 11 7.80222 11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9ZM14 9C13.8022 9 13.6089 8.94135 13.4444 8.83147C13.28 8.72159 13.1518 8.56541 13.0761 8.38268C13.0004 8.19996 12.9806 7.99889 13.0192 7.80491C13.0578 7.61093 13.153 7.43275 13.2929 7.29289C13.4327 7.15304 13.6109 7.0578 13.8049 7.01921C13.9989 6.98063 14.2 7.00043 14.3827 7.07612C14.5654 7.15181 14.7216 7.27998 14.8315 7.44443C14.9414 7.60888 15 7.80222 15 8C15 8.26522 14.8946 8.51957 14.7071 8.70711C14.5196 8.89464 14.2652 9 14 9Z"
        fill="#ffffff"
      />
    </svg>
  );
};
export const ChangePasswordIcon = () => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7H17C17.2652 7 17.5196 7.10536 17.7071 7.29289C17.8946 7.48043 18 7.73478 18 8V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H1C0.734784 21 0.48043 20.8946 0.292893 20.7071C0.105357 20.5196 0 20.2652 0 20V8C0 7.73478 0.105357 7.48043 0.292893 7.29289C0.48043 7.10536 0.734784 7 1 7H3V6C3 4.4087 3.63214 2.88258 4.75736 1.75736C5.88258 0.632141 7.4087 0 9 0C10.5913 0 12.1174 0.632141 13.2426 1.75736C14.3679 2.88258 15 4.4087 15 6V7ZM13 7V6C13 4.93913 12.5786 3.92172 11.8284 3.17157C11.0783 2.42143 10.0609 2 9 2C7.93913 2 6.92172 2.42143 6.17157 3.17157C5.42143 3.92172 5 4.93913 5 6V7H13ZM8 13V15H10V13H8ZM4 13V15H6V13H4ZM12 13V15H14V13H12Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const LogOutIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 20C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V19C16 19.2652 15.8946 19.5196 15.7071 19.7071C15.5196 19.8946 15.2652 20 15 20H1ZM11 14L16 10L11 6V9H5V11H11V14Z"
        fill="#5D5E60"
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0618 17.6975C20.1388 16.4016 20.888 14.8653 21.2458 13.2186C21.6035 11.572 21.5595 9.86334 21.1173 8.23731C20.6751 6.61128 19.8477 5.11567 18.7052 3.87701C17.5628 2.63834 16.1388 1.69306 14.5537 1.12114C12.9686 0.54921 11.2691 0.367458 9.59897 0.591258C7.92881 0.815058 6.33711 1.43783 4.95854 2.40688C3.57996 3.37593 2.45506 4.66276 1.67899 6.1585C0.902928 7.65425 0.498528 9.31491 0.500004 11C0.50057 13.4496 1.36381 15.8208 2.93825 17.6975L2.92325 17.7102C2.97575 17.7732 3.03575 17.8272 3.08975 17.8895C3.15725 17.9667 3.23 18.0395 3.29975 18.1145C3.50975 18.3425 3.72575 18.5615 3.95225 18.767C4.02125 18.83 4.0925 18.8885 4.16225 18.9485C4.40225 19.1555 4.649 19.352 4.90475 19.535C4.93775 19.5575 4.96775 19.5867 5.00075 19.61V19.601C6.75733 20.8371 8.85283 21.5005 11.0008 21.5005C13.1487 21.5005 15.2442 20.8371 17.0008 19.601V19.61C17.0338 19.5867 17.063 19.5575 17.0968 19.535C17.3518 19.3512 17.5993 19.1555 17.8393 18.9485C17.909 18.8885 17.9803 18.8292 18.0493 18.767C18.2758 18.5607 18.4918 18.3425 18.7018 18.1145C18.7715 18.0395 18.8435 17.9667 18.9118 17.8895C18.965 17.8272 19.0258 17.7732 19.0783 17.7095L19.0618 17.6975ZM11 5C11.6675 5 12.32 5.19794 12.8751 5.56879C13.4301 5.93964 13.8627 6.46674 14.1181 7.08344C14.3735 7.70014 14.4404 8.37874 14.3102 9.03343C14.1799 9.68811 13.8585 10.2895 13.3865 10.7615C12.9145 11.2335 12.3131 11.5549 11.6584 11.6851C11.0037 11.8154 10.3251 11.7485 9.70845 11.4931C9.09175 11.2376 8.56464 10.8051 8.19379 10.25C7.82294 9.69503 7.625 9.04251 7.625 8.375C7.625 7.47989 7.98058 6.62145 8.61352 5.98851C9.24645 5.35558 10.1049 5 11 5ZM5.00525 17.6975C5.01826 16.7127 5.41846 15.7727 6.11927 15.0807C6.82008 14.3887 7.76514 14.0005 8.75 14H13.25C14.2349 14.0005 15.1799 14.3887 15.8807 15.0807C16.5815 15.7727 16.9817 16.7127 16.9948 17.6975C15.3499 19.1797 13.2142 20.0001 11 20.0001C8.78581 20.0001 6.65012 19.1797 5.00525 17.6975Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const PaymentIcon = () => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.714355 2.64285C0.714355 2.0177 0.962697 1.41815 1.40475 0.976097C1.8468 0.534047 2.44634 0.285706 3.0715 0.285706H18.9286C19.5538 0.285706 20.1533 0.534047 20.5954 0.976097C21.0374 1.41815 21.2858 2.0177 21.2858 2.64285V4.57142H0.714355V2.64285Z"
        fill="#5D5E60"
      />
      <path
        d="M0.714355 5.85715H21.2858V12.5C21.2858 13.1252 21.0374 13.7247 20.5954 14.1668C20.1533 14.6088 19.5538 14.8571 18.9286 14.8571H3.0715C2.44634 14.8571 1.8468 14.6088 1.40475 14.1668C0.962697 13.7247 0.714355 13.1252 0.714355 12.5V5.85715ZM14.8572 10.0571C14.6526 10.0571 14.4564 10.1384 14.3117 10.2831C14.1671 10.4278 14.0858 10.624 14.0858 10.8286C14.0858 11.0332 14.1671 11.2294 14.3117 11.3741C14.4564 11.5187 14.6526 11.6 14.8572 11.6H17.4286C17.6332 11.6 17.8295 11.5187 17.9741 11.3741C18.1188 11.2294 18.2001 11.0332 18.2001 10.8286C18.2001 10.624 18.1188 10.4278 17.9741 10.2831C17.8295 10.1384 17.6332 10.0571 17.4286 10.0571H14.8572Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const VideoIcon = () => (
  <svg
    className="cursor-pointer size-video-icon"
    width="42"
    height="42"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="28" y="24" width="40" height="48" fill="white" />
    <path
      d="M48 6C24.8063 6 6 24.8063 6 48C6 71.1937 24.8063 90 48 90C71.1937 90 90 71.1937 90 48C90 24.8063 71.1937 6 48 6ZM61.5094 48.6469L41.0344 63.5437C40.9221 63.6244 40.7898 63.6726 40.652 63.6829C40.5141 63.6933 40.3761 63.6654 40.2531 63.6025C40.13 63.5395 40.0267 63.4438 39.9545 63.326C39.8823 63.2081 39.844 63.0726 39.8438 62.9344V33.1594C39.8433 33.0209 39.8812 32.885 39.9533 32.7667C40.0253 32.6484 40.1287 32.5524 40.252 32.4893C40.3753 32.4262 40.5137 32.3984 40.6518 32.4092C40.7899 32.4199 40.9223 32.4686 41.0344 32.55L61.5094 47.4375C61.6061 47.5059 61.685 47.5965 61.7395 47.7017C61.7939 47.807 61.8224 47.9237 61.8224 48.0422C61.8224 48.1607 61.7939 48.2774 61.7395 48.3826C61.685 48.4878 61.6061 48.5785 61.5094 48.6469Z"
      fill="#127CF9"
    />
  </svg>
);
export const EditPencil = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.666 0H6.66602C3.35702 0 0.666016 2.691 0.666016 6V19C0.666016 19.2652 0.771372 19.5196 0.958909 19.7071C1.14645 19.8946 1.4008 20 1.66602 20H14.666C17.975 20 20.666 17.309 20.666 14V6C20.666 2.691 17.975 0 14.666 0ZM7.66502 15H5.66602V13.001L11.196 7.479L13.195 9.478L7.66502 15ZM14.138 8.535L12.139 6.536L13.663 5.013L15.662 7.012L14.138 8.535Z"
        fill="white"
      />
    </svg>
  );
};
export const RemoveIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.166 5C19.166 5.24493 19.0761 5.48134 18.9133 5.66437C18.7505 5.84741 18.5263 5.96434 18.283 5.993L18.166 6H17.321L16.09 18.52C16.023 19.1994 15.7057 19.8295 15.1998 20.2879C14.6939 20.7462 14.0357 21.0001 13.353 21H5.97902C5.29636 21.0001 4.63809 20.7462 4.13222 20.2879C3.62634 19.8295 3.30904 19.1994 3.24202 18.52L2.01102 6H1.16602C0.900799 6 0.646445 5.89464 0.458909 5.70711C0.271372 5.51957 0.166016 5.26522 0.166016 5C0.166016 4.73478 0.271372 4.48043 0.458909 4.29289C0.646445 4.10536 0.900799 4 1.16602 4H6.16602C6.16602 3.54037 6.25655 3.08525 6.43244 2.66061C6.60833 2.23597 6.86614 1.85013 7.19114 1.52513C7.51615 1.20012 7.90198 0.942313 8.32662 0.766422C8.75126 0.59053 9.20639 0.5 9.66602 0.5C10.1256 0.5 10.5808 0.59053 11.0054 0.766422C11.43 0.942313 11.8159 1.20012 12.1409 1.52513C12.4659 1.85013 12.7237 2.23597 12.8996 2.66061C13.0755 3.08525 13.166 3.54037 13.166 4H18.166C18.4312 4 18.6856 4.10536 18.8731 4.29289C19.0607 4.48043 19.166 4.73478 19.166 5ZM11.916 8.25C11.7348 8.25001 11.5597 8.31564 11.4231 8.43477C11.2865 8.55389 11.1977 8.71845 11.173 8.898L11.166 9V16L11.173 16.102C11.1977 16.2815 11.2866 16.446 11.4232 16.5651C11.5597 16.6842 11.7348 16.7498 11.916 16.7498C12.0972 16.7498 12.2723 16.6842 12.4089 16.5651C12.5455 16.446 12.6343 16.2815 12.659 16.102L12.666 16V9L12.659 8.898C12.6344 8.71845 12.5455 8.55389 12.4089 8.43477C12.2724 8.31564 12.0973 8.25001 11.916 8.25ZM7.41602 8.25C7.23478 8.25001 7.05967 8.31564 6.92309 8.43477C6.7865 8.55389 6.69766 8.71845 6.67302 8.898L6.66602 9V16L6.67302 16.102C6.69771 16.2815 6.78657 16.446 6.92315 16.5651C7.05974 16.6842 7.23481 16.7498 7.41602 16.7498C7.59722 16.7498 7.77229 16.6842 7.90888 16.5651C8.04546 16.446 8.13432 16.2815 8.15902 16.102L8.16602 16V9L8.15902 8.898C8.13437 8.71845 8.04553 8.55389 7.90895 8.43477C7.77236 8.31564 7.59725 8.25001 7.41602 8.25ZM9.66602 2.5C9.26819 2.5 8.88666 2.65804 8.60536 2.93934C8.32405 3.22064 8.16602 3.60218 8.16602 4H11.166C11.166 3.60218 11.008 3.22064 10.7267 2.93934C10.4454 2.65804 10.0638 2.5 9.66602 2.5Z"
        fill="#5D5E60"
      />
    </svg>
  );
};

export const Attachmaent = () => {
  return (
    <svg
      className=" me-xxl-3 me-2"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.129 2.68558C14.3656 2.64067 13.5154 2.89879 12.7073 3.70691L3.7073 12.7069C2.39918 14.015 1.95356 15.4277 2.02972 16.7223C2.10732 18.0416 2.73296 19.3184 3.7073 20.2927C4.68163 21.267 5.95843 21.8927 7.27766 21.9703C8.57232 22.0464 9.98496 21.6008 11.2931 20.2927L20.2931 11.2927L21.7073 12.7069L12.7073 21.7069C11.0154 23.3988 9.05307 24.0782 7.16022 23.9668C5.29195 23.8569 3.56875 22.9826 2.29308 21.7069C1.01742 20.4312 0.143065 18.708 0.033167 16.8398C-0.0781768 14.9469 0.601206 12.9846 2.29308 11.2927L11.2931 2.2927C12.485 1.10082 13.8848 0.608938 15.2464 0.689032C16.5834 0.76768 17.8066 1.39204 18.7073 2.2927C19.608 3.19336 20.2323 4.41657 20.311 5.75358C20.3911 7.11518 19.8992 8.51504 18.7073 9.70691L9.7073 18.7069C9.01542 19.3988 8.17807 19.7032 7.34772 19.6543C6.54195 19.6069 5.81875 19.2326 5.29309 18.7069C4.76742 18.1812 4.39307 17.458 4.34567 16.6523C4.29682 15.8219 4.60121 14.9846 5.29309 14.2927L14.2931 5.2927L15.7073 6.70691L6.7073 15.7069C6.39918 16.015 6.32856 16.3027 6.34222 16.5348C6.35732 16.7916 6.48296 17.0684 6.7073 17.2927C6.93163 17.517 7.20843 17.6427 7.46516 17.6578C7.69732 17.6714 7.98496 17.6008 8.29309 17.2927L17.2931 8.2927C18.1012 7.48458 18.3593 6.63443 18.3144 5.87103C18.2681 5.08304 17.8924 4.30625 17.2931 3.70691C16.6937 3.10758 15.917 2.73193 15.129 2.68558Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const BackIconImg = () => {
  return (
    <svg
      className="me-md-3 me-1"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7166 0.636907C5.71672 0.504198 5.67542 0.374772 5.59849 0.266742C5.52156 0.158713 5.41284 0.0774849 5.28755 0.0344262C5.16226 -0.00863255 5.02666 -0.0113673 4.89974 0.0266046C4.77283 0.0645766 4.66093 0.141355 4.57972 0.246195L0.133818 5.97324C0.0470881 6.08494 0 6.22243 0 6.36395C0 6.50547 0.0470881 6.64296 0.133818 6.75466L4.57972 12.4817C4.66093 12.5865 4.77283 12.6633 4.89974 12.7013C5.02666 12.7393 5.16226 12.7365 5.28755 12.6935C5.41284 12.6504 5.52156 12.5692 5.59849 12.4612C5.67542 12.3531 5.71672 12.2237 5.7166 12.091V9.552C9.13296 9.62327 10.7741 10.273 11.5985 10.9793C12.3823 11.6506 12.5258 12.4403 12.6751 13.2676L12.7138 13.4808C12.7423 13.6333 12.8255 13.7701 12.9476 13.8655C13.0698 13.9609 13.2225 14.0083 13.3771 13.9988C13.5317 13.9893 13.6775 13.9234 13.7871 13.8137C13.8966 13.704 13.9624 13.558 13.972 13.4031C14.0806 11.6545 13.9174 9.12057 12.6846 7.00092C11.488 4.94364 9.33303 3.36171 5.7166 3.19626V0.636907Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const ReleasedIcon = () => {
  return (
    <svg
      className="mx-sm-2 mx-1"
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22424 29.886C6.45224 30.282 5.57624 29.588 5.73224 28.702L7.39224 19.242L0.346237 12.53C-0.311763 11.902 0.0302365 10.754 0.912237 10.63L10.7082 9.23802L15.0762 0.584023C15.4702 -0.195977 16.5362 -0.195977 16.9302 0.584023L21.2982 9.23802L31.0942 10.63C31.9762 10.754 32.3182 11.902 31.6582 12.53L24.6142 19.242L26.2742 28.702C26.4302 29.588 25.5542 30.282 24.7822 29.886L16.0002 25.374L7.22224 29.886H7.22424Z"
        fill="#FAA611"
      />
    </svg>
  );
};

export const JobCompletedIcon = () => {
  return (
    <svg
      className="mx-sm-2 mx-1"
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22424 29.886C6.45224 30.282 5.57624 29.588 5.73224 28.702L7.39224 19.242L0.346237 12.53C-0.311763 11.902 0.0302365 10.754 0.912237 10.63L10.7082 9.23802L15.0762 0.584023C15.4702 -0.195977 16.5362 -0.195977 16.9302 0.584023L21.2982 9.23802L31.0942 10.63C31.9762 10.754 32.3182 11.902 31.6582 12.53L24.6142 19.242L26.2742 28.702C26.4302 29.588 25.5542 30.282 24.7822 29.886L16.0002 25.374L7.22224 29.886H7.22424Z"
        fill="#FAA611"
      />
    </svg>
  );
};
export const AccountIcon = () => {
  return (
    <svg
      className="mx-sm-2 mx-1"
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22424 29.886C6.45224 30.282 5.57624 29.588 5.73224 28.702L7.39224 19.242L0.346237 12.53C-0.311763 11.902 0.0302365 10.754 0.912237 10.63L10.7082 9.23802L15.0762 0.584023C15.4702 -0.195977 16.5362 -0.195977 16.9302 0.584023L21.2982 9.23802L31.0942 10.63C31.9762 10.754 32.3182 11.902 31.6582 12.53L24.6142 19.242L26.2742 28.702C26.4302 29.588 25.5542 30.282 24.7822 29.886L16.0002 25.374L7.22224 29.886H7.22424Z"
        fill="#FAA611"
      />
    </svg>
  );
};
export const JobIcon = () => {
  return (
    <svg
      className="mx-sm-2 mx-1"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73224 29.7001C5.57624 30.5881 6.45224 31.2821 7.22424 30.8861L16.0042 26.3741L24.7822 30.8861C25.5542 31.2821 26.4302 30.5881 26.2742 29.7021L24.6142 20.2421L31.6582 13.5301C32.3182 12.9021 31.9782 11.7541 31.0942 11.6301L21.2982 10.2381L16.9302 1.58409C16.847 1.40867 16.7157 1.26046 16.5517 1.15668C16.3876 1.05289 16.1974 0.997803 16.0032 0.997803C15.8091 0.997803 15.6189 1.05289 15.4548 1.15668C15.2907 1.26046 15.1594 1.40867 15.0762 1.58409L10.7082 10.2401L0.912237 11.6321C0.0302365 11.7561 -0.311763 12.9041 0.346237 13.5321L7.39224 20.2441L5.73224 29.7041V29.7001ZM15.5422 24.1661L8.17024 27.9541L9.55824 20.0401C9.59075 19.8579 9.57803 19.6705 9.52119 19.4944C9.46434 19.3183 9.36512 19.1589 9.23224 19.0301L3.42024 13.4901L11.5242 12.3381C11.692 12.3127 11.8512 12.2471 11.9881 12.1468C12.125 12.0465 12.2355 11.9145 12.3102 11.7621L16.0002 4.44609L19.6942 11.7621C19.7689 11.9145 19.8795 12.0465 20.0164 12.1468C20.1533 12.2471 20.3124 12.3127 20.4802 12.3381L28.5842 13.4881L22.7722 19.0281C22.639 19.1571 22.5396 19.3169 22.4828 19.4934C22.4259 19.6698 22.4134 19.8576 22.4462 20.0401L23.8342 27.9541L16.4622 24.1661C16.3197 24.0926 16.1616 24.0542 16.0012 24.0542C15.8409 24.0542 15.6828 24.0926 15.5402 24.1661H15.5422Z"
        fill="#B9BABB"
      />
    </svg>
  );
};
export const DisputeIcons = () => {
  return (
    <svg
      className="mx-sm-2 mx-1"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73224 29.7001C5.57624 30.5881 6.45224 31.2821 7.22424 30.8861L16.0042 26.3741L24.7822 30.8861C25.5542 31.2821 26.4302 30.5881 26.2742 29.7021L24.6142 20.2421L31.6582 13.5301C32.3182 12.9021 31.9782 11.7541 31.0942 11.6301L21.2982 10.2381L16.9302 1.58409C16.847 1.40867 16.7157 1.26046 16.5517 1.15668C16.3876 1.05289 16.1974 0.997803 16.0032 0.997803C15.8091 0.997803 15.6189 1.05289 15.4548 1.15668C15.2907 1.26046 15.1594 1.40867 15.0762 1.58409L10.7082 10.2401L0.912237 11.6321C0.0302365 11.7561 -0.311763 12.9041 0.346237 13.5321L7.39224 20.2441L5.73224 29.7041V29.7001ZM15.5422 24.1661L8.17024 27.9541L9.55824 20.0401C9.59075 19.8579 9.57803 19.6705 9.52119 19.4944C9.46434 19.3183 9.36512 19.1589 9.23224 19.0301L3.42024 13.4901L11.5242 12.3381C11.692 12.3127 11.8512 12.2471 11.9881 12.1468C12.125 12.0465 12.2355 11.9145 12.3102 11.7621L16.0002 4.44609L19.6942 11.7621C19.7689 11.9145 19.8795 12.0465 20.0164 12.1468C20.1533 12.2471 20.3124 12.3127 20.4802 12.3381L28.5842 13.4881L22.7722 19.0281C22.639 19.1571 22.5396 19.3169 22.4828 19.4934C22.4259 19.6698 22.4134 19.8576 22.4462 20.0401L23.8342 27.9541L16.4622 24.1661C16.3197 24.0926 16.1616 24.0542 16.0012 24.0542C15.8409 24.0542 15.6828 24.0926 15.5402 24.1661H15.5422Z"
        fill="#B9BABB"
      />
    </svg>
  );
};
export const ViewBackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="24"
      height="24"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#5d5e60"
        d="M396 512a112 112 0 1 0 224 0a112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176s-78.8 176-176 176z"
      />
    </svg>
  );
};
export const StartDisputeIcon = () => {
  return (
    <svg
      className="me-2"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 18H6V22.081L11.101 18H16C17.103 18 18 17.103 18 16V8C18 6.897 17.103 6 16 6H4C2.897 6 2 6.897 2 8V16C2 17.103 2.897 18 4 18Z"
        fill="#5D5E60"
      />
      <path
        d="M20 2H8C6.897 2 6 2.897 6 4H18C19.103 4 20 4.897 20 6V14C21.103 14 22 13.103 22 12V4C22 2.897 21.103 2 20 2Z"
        fill="#5D5E60"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 35.5001C15.7012 35.5024 13.4246 35.0513 11.3003 34.1727C9.17609 33.294 7.24599 32.0051 5.62051 30.3796C3.99502 28.7541 2.70607 26.824 1.82743 24.6998C0.948786 22.5755 0.497707 20.2989 0.500009 18.0001V17.6501C0.570023 14.219 1.64677 10.8842 3.59644 8.06012C5.5461 5.23599 8.2827 3.04708 11.4661 1.76543C14.6496 0.48378 18.1395 0.165903 21.502 0.851308C24.8646 1.53671 27.9517 3.19518 30.3795 5.62058C32.829 8.06804 34.4974 11.1872 35.1735 14.5832C35.8495 17.9792 35.503 21.4995 34.1776 24.6984C32.8522 27.8974 30.6076 30.6313 27.7279 32.5541C24.8481 34.4769 21.4627 35.5021 18 35.5001ZM18 20.4676L22.5325 25.0001L25 22.5326L20.4675 18.0001L25 13.4676L22.5325 11.0001L18 15.5326L13.4675 11.0001L11 13.4676L15.5325 18.0001L11 22.5326L13.4675 25.0001L18 20.4693V20.4676Z"
        fill="#5D5E60"
      />
    </svg>
  );
};
export const StarIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_195_3330)">
        <path
          d="M7.22424 30.886C6.45224 31.282 5.57624 30.588 5.73224 29.702L7.39224 20.242L0.346237 13.53C-0.311763 12.902 0.0302365 11.754 0.912237 11.63L10.7082 10.238L15.0762 1.58402C15.4702 0.804023 16.5362 0.804023 16.9302 1.58402L21.2982 10.238L31.0942 11.63C31.9762 11.754 32.3182 12.902 31.6582 13.53L24.6142 20.242L26.2742 29.702C26.4302 30.588 25.5542 31.282 24.7822 30.886L16.0002 26.374L7.22224 30.886H7.22424Z"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_195_3330">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SendMessagesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="25"
      height="25"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="#ffffff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.912 12H4L2.023 4.135A.662.662 0 0 1 2 3.995c-.022-.721.772-1.221 1.46-.891L22 12L3.46 20.896c-.68.327-1.464-.159-1.46-.867a.66.66 0 0 1 .033-.186L3.5 15"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="24"
      height="24"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#5d5e60"
        d="M396 512a112 112 0 1 0 224 0a112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176s-78.8 176-176 176z"
      ></path>
    </svg>
  );
};
